import FormDropdown from "@components/Form/FormDropdown";
import FormInput from "@components/Form/FormInput";
import FormLabel from "@components/Form/FormLabel";
import FormRadio from "@components/Form/FormRadio";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import { StyledXSmall } from "@components/Styled/Text";
import { css } from "@emotion/react";
import React from "react";
import tw, { styled } from "twin.macro";
import { withFitFeedback } from "./withFitFeedback";

const FitWrapper = tw.div`w-full flex flex-col px-zero md:px-mini`;
const Fit = styledWithInvalidProps("div")(() => [
  tw`flex flex-col mb-midi md:items-center md:flex-row`,
  css`
    & label {
      ${tw`pb-zero`}
    }
  `,
]);

const FitHeading = styled(FormLabel)`
  ${css`
    & label {
      ${tw`opacity-50 text-h5 tracking-[1.2px]`}
    }
  `}
`;
const FitLabel = tw(FormLabel)``;
const FitOptionWrapper = tw.div`
    flex justify-between md:w-4/6 md:ml-midi
`;
const FitOption = tw(FormRadio)``;
const SizeDropdown = styled(FormDropdown)`
  ${({ error }) =>
    error
      ? css`
          ${tw`mb-zero`}
          & input {
            ${tw`border-b-2 text-warning border-warning`}
          }
        `
      : null}
`;
const SizeSelectorWrapper = tw.div`
  w-full flex flex-col px-zero mb-midi md:w-1/2 md:px-mini
`;
const ReviewTitle = styled(FormInput)`
  ${tw`w-full px-zero mb-midi md:w-1/2 md:px-mini`}
  ${css`
    & input {
      ${tw`h-maxi`}
    }
  `}
`;
const ErrorMessage = tw(StyledXSmall)`
  mb-mini text-orange mt-pico
`;

const FitFeedback = withFitFeedback(
  ({
    errors,
    fitLength,
    fitWidth,
    gender,
    handleFitWidthChange,
    handleFitLengthChange,
    handleSizeChange,
    handleTitleChange,
    sizeOptions,
    shoeFitLength,
    shoeFitWidth,
    title,
  }) => {
    return (
      <>
        <FitWrapper>
          <FitHeading
            id="fit-heading"
            label="HOW DID YOU FIND THE FIT?"
            required={false}
          />
          <Fit>
            <FitLabel id="fit-length" label="Shoe Length" required />
            <FitOptionWrapper>
              {shoeFitLength?.map(({ value, label }) => {
                return (
                  <FitOption
                    key={label}
                    dataTestId={label}
                    name={value}
                    label={label}
                    value={fitLength === value}
                    handleChange={handleFitLengthChange}
                    internalState
                  />
                );
              })}
            </FitOptionWrapper>
          </Fit>

          <Fit>
            <FitLabel id="fit-width" label="Shoe Width" required />
            <FitOptionWrapper>
              {shoeFitWidth?.map(({ value, label }) => {
                return (
                  <FitOption
                    key={label}
                    dataTestId={label}
                    name={value}
                    label={label}
                    value={fitWidth === value}
                    handleChange={handleFitWidthChange}
                    internalState
                  />
                );
              })}
            </FitOptionWrapper>
          </Fit>
        </FitWrapper>
        <SizeSelectorWrapper>
          <FitLabel
            id="size-selector"
            label="What is your usual shoe size?"
            required
          />
          <SizeDropdown
            dataTestId={`${gender}-sizes`}
            placeholder="Select a size"
            layout="form"
            options={sizeOptions}
            handleChange={handleSizeChange}
            error={!!errors["size"]}
          />
          {errors["size"] ? (
            <ErrorMessage>{errors["size"]}</ErrorMessage>
          ) : null}
        </SizeSelectorWrapper>
        <ReviewTitle
          data-testid="review-title"
          name="title"
          label="Review Title"
          width="1/2"
          value={title}
          handleChange={handleTitleChange}
        />
      </>
    );
  },
);

export default FitFeedback;
